import React from "react";

import Carousel from "components/core/Carousel";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

const testimonials = [
  {
    image: "/images/parent-1.png",
    parent: "Chị Thảo",
    child: "Phụ huynh bé 8 tuổi",
    testimonial:
      "Chương trình đào tạo của trung tâm rất chất lượng, đặc biệt là các hoạt động ứng dụng tiếng Anh vào thực tiễn. Tôi rất ngạc nhiên khi con phỏng vấn cha mẹ ở nhà hay tự làm bản đồ. Cảm ơn trung tâm. Chúc trung tâm ngày càng phát triển.",
  },
  {
    image: "/images/parent-2.png",
    parent: "Chị Hương",
    child: "Phụ huynh bé 6 tuổi",
    testimonial:
      "Tôi rất hài lòng về chất lượng giảng dạy và dịch vụ tại trung tâm. Các thầy cô dạy rất có tâm và nhiệt tình. Tôi nhận được báo cáo về tình hình học tập của con hàng ngày nên luôn theo sát được tình hình học tập của con.",
  },
  {
    image: "/images/parent-3.png",
    parent: "Anh Minh",
    child: "Phụ huynh bé 4 tuổi",
    testimonial:
      "Đồng hành cùng trung tâm từ những khoá học đầu tiên, tôi cảm thấy may mắn vì mình đã lựa chọn đúng môi trường học cho con. Con rất thích đi học và đã tự tin bắt chuyện và giao tiếp bằng tiếng Anh với giáo viên nước ngoài.",
  },
];

function Testimonial({ image, parent, child, testimonial }) {
  return (
    <Stack
      direction="row"
      justifyContent="center"
      spacing={2}
      useFlexGap
      flexWrap="wrap"
    >
      <img
        src={image}
        alt={parent}
        width={120}
        height={120}
        style={{ borderRadius: "50%" }}
      />
      <Stack maxWidth="600px">
        <Typography variant="body1" color="common.white" padding={1}>
          "{testimonial}"
        </Typography>
        <Typography
          variant="body2"
          color="common.white"
          fontWeight="bold"
          padding={1}
        >
          {parent} - {child}
        </Typography>
      </Stack>
    </Stack>
  );
}

function Testimonials() {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      padding={6}
      spacing={2}
      sx={{ backgroundColor: "primary.light" }}
    >
      <Typography variant="h2" color="common.white" align="center" gutterBottom>
        Chia sẻ của phụ huynh
      </Typography>

      <Carousel spacing="large" startIndex={0} numberToShow={1}>
        {testimonials.map((testimonial) => (
          <Testimonial key={testimonial.title} {...testimonial} />
        ))}
      </Carousel>
    </Stack>
  );
}

export default Testimonials;
